import { url } from '../Common/common';

export function getReferrals(pars, callback) {
    console.log('getReferrals', pars);
    let formData = new FormData();
    formData.append("user_id", pars.user_id);

    fetch(url + '/getreferrals', {
        method: 'POST',
        mode: 'cors',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data getReferrals', data);
        callback(data);
    })
    .catch((err) => {
        console.error('Ошибка getReferrals:', err);
        callback({ res: false, message: 'Ошибка при загрузке рефералов' });
    });
}

